import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

export type ChallengeUnit = {
  value: string;
  label?: {
    singular: string;
    plural: string;
  };
};

export const useChallengeUnits = () => {
  const { request } = useQueryHTTPRequest();
  const { data, isLoading, isError } = useQuery(
    [queryKeys.challengeTargetUnits],
    ({ signal }) => request({ url: '/api/challenges/units', signal }),
    {
      select: (data) => data.items,
      staleTime: Infinity, // Units don't change often, so we can cache them indefinitely
    }
  );

  const unitsMap = {} as { [key: string]: ChallengeUnit };
  if (data) {
    data.forEach((unit: ChallengeUnit) => {
      unitsMap[unit.value] = unit;
    });
  }

  const getUnitLabel = (unitValue: string, count: number): string => {
    const unit = unitsMap[unitValue];
    if (unit && unit.label) {
      return count === 1
        ? unit.label.singular.toLowerCase()
        : unit.label.plural.toLowerCase();
    }

    return unitValue.toLowerCase();
  };

  return {
    units: data || [],
    unitsMap: unitsMap,
    isLoading,
    isError,
    getUnitLabel,
  };
};
